import { Dictionary } from '../../../types/utils.types';
import { ReactComponent as Add } from './add.svg';
import { ReactComponent as Minus } from './minus.svg';
import { ReactComponent as Upload } from './upload.svg';
import { ReactComponent as Globe } from './globe.svg';
import { ReactComponent as ReactSelectDropDown } from './react-select-dropdown.svg';
import { ReactComponent as ReactSelectClose } from './react-select-close.svg';
import { ReactComponent as Checkbox } from './checkbox.svg';
import { ReactComponent as MailInvitation } from './mail-invitation.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as EmailEdit } from './email-edit.svg';
import { ReactComponent as EmailReload } from './email-reload.svg';
import { ReactComponent as EmailSubmit } from './email-submit.svg';
import { ReactComponent as EmailClose } from './email-close.svg';
import { ReactComponent as Time } from './time.svg';
import { ReactComponent as Date } from './date.svg';
import { ReactComponent as Delete } from './delete.svg';
import { ReactComponent as NavigateBefore } from './navigate_before.svg';
import { ReactComponent as NavigateNext } from './navigate_next.svg';
import { ReactComponent as ExpandMoreWhite } from './expand-more-white.svg';
import { ReactComponent as Help } from './help.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as Marketplace } from './marketplace.svg';
import { ReactComponent as MoreApplication } from './more-application.svg';
import { ReactComponent as Notification } from './notification.svg';
import { ReactComponent as ShoppingCartWhite } from './shopping-cart-white.svg';
import { ReactComponent as QuotaInfo } from './quota-info.svg';
import { ReactComponent as QuotaCaret } from './quota-caret.svg';
import { ReactComponent as Filters } from './filter_list.svg';
import { ReactComponent as Next } from './next.svg';
import { ReactComponent as Previous } from './previous.svg';
import { ReactComponent as PaginationFirst } from './pagination_first.svg';
import { ReactComponent as PaginationLast } from './pagination_last.svg';
import { ReactComponent as Link } from './link.svg';
import { ReactComponent as Person } from './person.svg';
import { ReactComponent as People } from './people.svg';
import { ReactComponent as AccessTime } from './access_time.svg';
import { ReactComponent as LibraryBooks } from './library_books.svg';
import { ReactComponent as More } from './more_vertical.svg';
import { ReactComponent as Remove } from './remove_circle_outline.svg';
import { ReactComponent as Recruit } from './recruit.svg';
import { ReactComponent as Learn } from './learn.svg';
import { ReactComponent as Contests } from './contests.svg';
import { ReactComponent as Tests } from './tests.svg';
import { ReactComponent as University } from './university.svg';
import { ReactComponent as Library } from './library.svg';
import { ReactComponent as Interviews } from './interviews.svg';
import { ReactComponent as Backoffice } from './backoffice.svg';
import { ReactComponent as Updates } from './updates.svg';
import { ReactComponent as Archive } from './archive.svg';
import { ReactComponent as Clone } from './content_copy.svg';
import { ReactComponent as Unarchive } from './unarchive.svg';
import { ReactComponent as AddMore } from './add_more.svg';
import { ReactComponent as AddUser } from './add-user.svg';
import { ReactComponent as AITagIcon } from './ai-tag.svg';
import { ReactComponent as InterviewTupleIcon } from './interview_tupple_icon.svg';

import { ReactComponent as InfoOutline } from './info-outline.svg';
import { ReactComponent as Success } from './success.svg';
import { ReactComponent as Warning } from './warning.svg';
import { ReactComponent as ErrorOutline } from './error-outline.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as ArrowDown } from './arrow_down.svg';
import { ReactComponent as ArrowUp } from './arrow_up.svg';
import { ReactComponent as StickyNotes } from './sticky_notes.svg';
import { ReactComponent as Upcoming } from './upcoming.svg';
import { ReactComponent as Interviewed } from './interviewed.svg';
import { ReactComponent as Selected } from './selected.svg';

import { ReactComponent as PdfIcon } from './pdf-icon.svg';
import { ReactComponent as FilePreviewClose } from './file-preview-close.svg';
import { ReactComponent as Schedule } from './schedule.svg';
import { ReactComponent as InsertLink } from './insert_link.svg';
import { ReactComponent as ContentCopy } from './content_copy.svg';
import { ReactComponent as Sort } from './sort.svg';
import { ReactComponent as Accepted } from './accepted.svg';
import { ReactComponent as AcceptedTentatively } from './accepted_tentatively.svg';
import { ReactComponent as Pending } from './pending.svg';
import { ReactComponent as Cancel } from './cancel.svg';
import { ReactComponent as Refresh } from './refresh.svg';
import { ReactComponent as Rounds } from './rounds.svg';
import { ReactComponent as Resend } from './mail.svg';
import { ReactComponent as CancelInvitation } from './cancel_invitation.svg';
import { ReactComponent as HTMLReport } from './html_report.svg';
import { ReactComponent as PDFReport } from './pdf_report.svg';

import { ReactComponent as KeyboardArrowLeft } from './keyboard_arrow_left.svg';
import { ReactComponent as KeyboardArrowRight } from './keyboard_arrow_right.svg';
import { ReactComponent as KeyboardArrowDown } from './keyboard_arrow_down.svg';
import { ReactComponent as KeyboardArrowUp } from './keyboard_arrow_up.svg';
import { ReactComponent as KeyboardDoubleArrowLeft } from './keyboard_double_arrow_left.svg';
import { ReactComponent as KeyboardDoubleArrowRight } from './keyboard_double_arrow_right.svg';
import { ReactComponent as FilterList } from './filter_list.svg';
import { ReactComponent as Email } from './email.svg';
import { ReactComponent as Download } from './download.svg';
import { ReactComponent as Ellipse } from './ellipse.svg';
import { ReactComponent as Star } from './star.svg';
import { ReactComponent as Play } from './play.svg';
import { ReactComponent as Pause } from './pause.svg';
import { ReactComponent as ThumbDown } from './thumb_down.svg';
import { ReactComponent as ThumbOnHold } from './thumb_on_hold.svg';
import { ReactComponent as ThumbUpOffAlt } from './thumb_up_off_alt.svg';
import { ReactComponent as HourGlassBottom } from './hourglass_bottom.svg';
import { ReactComponent as Subject } from './subject.svg';
import { ReactComponent as Logout } from './logout.svg';
import { ReactComponent as MoreApps } from './more.svg';
import { ReactComponent as WarningCircle } from './warning-circle.svg';
import { ReactComponent as WarningCircleOutline } from './warning-circle-outline.svg';
import { ReactComponent as InvitationStatus } from './invitation_status.svg';
import { ReactComponent as Read } from './read.svg';
import { ReactComponent as NoInterviewListIcon } from './no-interview-list.svg';
import { ReactComponent as AcceptFilled } from './accepted_filled.svg';
import { ReactComponent as WarningFilled } from './warning_filled.svg';
import { ReactComponent as DeleteBin } from './delete-bin.svg';
import { ReactComponent as Deactivate } from './deactivate.svg';
import { ReactComponent as Interchange } from './interchange.svg';
import { ReactComponent as ResendInvite } from './resend.svg';
import { ReactComponent as EditSetting } from './edit_setting.svg';
import { ReactComponent as Usage } from './data_usage.svg';
import { ReactComponent as Dashboard } from './dashboard.svg';
import { ReactComponent as Face } from './face.svg';
import { ReactComponent as Cross } from './cross.svg';
import { ReactComponent as AlertWarning } from './alert_warning.svg';
import { ReactComponent as SendInvite } from './send.svg';
import { ReactComponent as ShortText } from './short_text.svg';
import { ReactComponent as ActivateMember } from './activate_member.svg';
import { ReactComponent as LazyLogin } from './lazyLogin.svg';
import { ReactComponent as Dhwani } from './dhwani.svg';
import { ReactComponent as InviteMembers } from './inviteMember.svg';
import { ReactComponent as FileAttach } from './file_attach.svg';
import { ReactComponent as CopyLink } from './copy_link.svg';
import { ReactComponent as Info } from './info.svg';

const Icons: Dictionary<
  React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>
> = {
  add: Add,
  upload: Upload,
  minus: Minus,
  globe: Globe,
  reactSelectDropDown: ReactSelectDropDown,
  reactSelectClose: ReactSelectClose,
  checkbox: Checkbox,
  mailInvitation: MailInvitation,
  emailEdit: EmailEdit,
  edit: Edit,
  emailReload: EmailReload,
  emailSubmit: EmailSubmit,
  emailClose: EmailClose,
  time: Time,
  date: Date,
  delete: Delete,

  // Navbar and Secondary navigation icons
  navigateNext: NavigateNext,
  navigateBefore: NavigateBefore,
  expandMoreWhite: ExpandMoreWhite,
  help: Help,
  search: Search,
  marketplace: Marketplace,
  moreApplication: MoreApplication,
  notification: Notification,
  shoppingCartWhite: ShoppingCartWhite,
  quotaInfo: QuotaInfo,
  quotaCaret: QuotaCaret,
  filters: Filters,
  next: Next,
  previous: Previous,
  paginationFirst: PaginationFirst,
  paginationLast: PaginationLast,
  link: Link,
  person: Person,
  people: People,
  accessTime: AccessTime,
  libraryBooks: LibraryBooks,
  more: More,
  remove: Remove,
  recruit: Recruit,
  learn: Learn,
  contests: Contests,
  dhwani: Dhwani,
  tests: Tests,
  university: University,
  library: Library,
  interviews: Interviews,
  backoffice: Backoffice,
  updates: Updates,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  archive: Archive,
  clone: Clone,
  unarchive: Unarchive,
  addMore: AddMore,
  stickyNotes: StickyNotes,
  upcoming: Upcoming,
  interviewed: Interviewed,
  selected: Selected,

  // Alert Icons
  infoOutline: InfoOutline,
  success: Success,
  warning: Warning,
  errorOutline: ErrorOutline,
  close: Close,

  pdfIcon: PdfIcon,
  filePreviewClose: FilePreviewClose,

  schedule: Schedule,
  insertLink: InsertLink,
  contentCopy: ContentCopy,
  sort: Sort,
  accepted: Accepted,
  acceptedTentatively: AcceptedTentatively,
  pending: Pending,
  cancel: Cancel,
  refresh: Refresh,
  rounds: Rounds,
  resend: Resend,
  cancelInvitation: CancelInvitation,
  htmlReport: HTMLReport,
  pdfReport: PDFReport,
  keyboardArrowLeft: KeyboardArrowLeft,
  keyboardArrowRight: KeyboardArrowRight,
  keyboardArrowUp: KeyboardArrowUp,
  keyboardArrowDown: KeyboardArrowDown,
  keyboardDoubleArrowLeft: KeyboardDoubleArrowLeft,
  keyboardDoubleArrowRight: KeyboardDoubleArrowRight,
  filterList: FilterList,
  email: Email,
  download: Download,
  ellipse: Ellipse,
  star: Star,
  play: Play,
  pause: Pause,
  thumbDown: ThumbDown,
  thumbOnHold: ThumbOnHold,
  thumbUpOffAlt: ThumbUpOffAlt,
  hourGlassBottom: HourGlassBottom,
  moreApps: MoreApps,
  subject: Subject,
  logout: Logout,
  warningCircle: WarningCircle,
  warningCircleOutline: WarningCircleOutline,
  warningFilled: WarningFilled,
  invitationStatus: InvitationStatus,
  read: Read,
  noInterviewListIcon: NoInterviewListIcon,
  addUser: AddUser,
  interviewTupleIcon: InterviewTupleIcon,
  aiTagIcon: AITagIcon,
  acceptFilled: AcceptFilled,

  // recruiter dashboard
  inviteMembers: InviteMembers,
  deleteBin: DeleteBin,
  interchange: Interchange,
  deactivate: Deactivate,
  resendInvite: ResendInvite,
  cross: Cross,
  alertWarning: AlertWarning,
  sendInvite: SendInvite,
  activateMember: ActivateMember,

  // BackOffice Roles
  editSetting: EditSetting,
  usage: Usage,
  dashboard: Dashboard,
  face: Face,
  shortText: ShortText,
  lazyLogin: LazyLogin,
  fileAttach: FileAttach,
  copyLink: CopyLink,
  info: Info,
};

export default Icons;
